module.exports = __webpack_public_path__ + "static/pitchi2x-1de7913039d632f39b0f4d9b358c4661.jpg";